import React from 'react'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import { Link } from '@ta-interaktiv/contentbricks'

export const isMobile: boolean = browserCheck.isMobile

const updates = { evening: 'Actualisé à 18 heures, sauf durant le week-end' }

const metaCases = 'Fälle'

export const localesHospitalMultiples = {
  title: 'Patients covid à l’hôpital',
  subline: (
    <>
      Les données de l’OFSP sur les capacités hospitalières ne sont plus
      actualisées depuis le 2 mai 2023.
    </>
  ),
  link: (
    <>
      Taux d’occupation des hôpitaux par canton:{' '}
      <Link href='TODO-wch-story-id'>Voir les infographies</Link>.
    </>
  ),
  update: updates.evening,
  swissTitle: 'En Suisse',
  keyHosp: 'Hospitalisé',
  keyIntensive: 'En soins intensifs',
  metaCases: metaCases,
  showMoreClosed: 'Voir tous les cantons',
  showMoreOpened: 'Voir une sélection de cantons',
  noData: 'Pas de données',
  emptyData: 'Pas de données',
  timerange: ['Période']
}
